export default __webpack_public_path__ + "static/media/Ballroll_00177.06abeaab.png";